export default __webpack_public_path__ + "static/media/day_sky.52135992.jpg";